import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    promoterRegDate: String,
    promoterNumber: String,
  };

  initialize() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "promoter_sign_up",
      promoter_reg_date: this.promoterRegDateValue || undefined,
      promoter_number: this.promoterNumberValue || undefined,
    });
  }
}
